<template>
  <div class="col-12">
    <div class=" row text-center m-5" v-show="customerDetailsDiv">
      <h3 class="ui inverted purple text"><strong> Customer Details</strong></h3>
      <p class="text-muted fw-light mr-4 ml-4">
      </p>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-10 col-lg-6" v-show="customerDetailsDiv">
        <form class="ui big form" v-bind:class="{ 'ui form loading': isBusy() }" @submit.prevent="submitForm()">

          <div class="field">
            <label>Mobile Number</label>
            <input type="text" name="mobileNumber" v-model="customer.mobileNumber" placeholder="Mobile Number" disabled>
          </div>

          <div class="field">
            <label>First Name</label>
            <input type="text" name="firstName" v-model="customer.firstName" placeholder="First Name" disabled>
          </div>

          <div class="field">
            <label>Last Name</label>
            <input class="ui large" type="text" name="lastName" v-model="customer.lastName" placeholder="Last Name"
              disabled>
          </div>

          <div class="field">
            <label>ID Number</label>
            <input type="text" name="identityDocNo" v-model="customer.identityDocNo" placeholder="ID Number" disabled>
          </div>

          <button class="fluid ui purple button mt-5" v-bind:disabled="isBusy()" type="submit">
            Next
          </button>
          <button class="ui button  grey fluid mt-4 mb-4" @click="back()">Back</button>
        </form>
      </div>
    </div>

    <div v-show="makePaymentElement">
      <div class=" row text-center m-5">
        <h3 v-if="success" class="ui inverted purple text"> <strong> {{ title }}</strong>
        </h3>
        <h3 v-if="!success" class="ui inverted purple text"><strong> {{
          title
        }}</strong>
        </h3>

      </div>
      <div class="row d-flex justify-content-center align-items-center mt-5">
        <div class="col-11 col-lg-9">
          <div class="ui violet floating message m-4">
            <div class="header mb-2">
              <div v-if="loadingRequest" class="ui active inline loader"></div>
              {{ subTitle }}
            </div>
            <p> {{ message }}</p>
          </div>
          <button v-if="retryButton" class="ui button  purple fluid mt-4 mb-4" @click="submitForm()">Retry
            Payment</button>
          <button v-if="logoutButton" class="ui button  grey fluid mt-4 mb-4" @click="login()">Logout</button>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { useAuthStore } from '@/stores/auth';
import { clearPersistedState } from '@/stores';
import { useCustomerStore } from '@/stores/customer';
import { useAccountOpeningStore } from '@/stores/accountOpening';

export default {
  name: 'CustomerDetails',
  setup() {
    const authStore = useAuthStore();
    const customerStore = useCustomerStore();
    const accountOpeningStore = useAccountOpeningStore();
    return { authStore, customerStore, accountOpeningStore };
  },
  data() {
    return {
      subTitle: '',
      title: '',
      message: '',
      success: true,
      retryButton: false,
      loadingRequest: false,
      logoutButton: false,
      customerDetailsDiv: true,
      makePaymentElement: false,
      customer: {
        mobileNumber: '',
        firstName: "",
        lastName: "",
        identityDocNo: "",
        gotCustomerData: false,
        requestType: "FETCH_CUSTOMER_DETAILS",

      },
      errors: {},
      operations: 0,
    };
  },
  computed: {
    phone() { return this.authStore.phone; },
  },
  created() {
    this.customer.mobileNumber = this.phone;
  },
  mounted() {
    this.postNoAuthAndNoBaseUrl(
      URLS.processAccount,
      this.customer,
      "Got Customer Data",
      null,
      true
    ).then((res) => {
      if (!res) return;
      if (res.errors) return (this.errors = res.errors);
      if (res.body.status === 'COMPLETE') {
        this.customer.firstName = res.body.firstName;
        this.customer.lastName = res.body.lastName;
        this.customer.identityDocNo = res.body.idNumber;
        this.customer.gotCustomerData = true;
        this.customer.button = "Confirm Your Details";
        this.customer.requestType = "PROCESS_ISAVE_ACCOUNT";
        this.customer.accountType = "ZSS";
        this.customer.header = "Please Confirm Your Customer Details";
      }
      else {
        this.$router.push("/account-opening/isave-failed");
      }
    });
  },
  methods: {
    close() {
      // todo: send close request to backend
    },
    setDefaults() {

      this.message = 'In approximately 10 seconds you will be asked to enter your EcoCash PIN  on your mobile phone to facilitate the account opening fee. This will enable us to co that we can accept your account opening request.';
      this.title = 'Almost Done!';
      this.subTitle = 'Pending Ecocash Payment Authorization';
      this.success = true;
      this.retryButton = false;
      this.logoutButton = false;
      this.loadingRequest = true;
      this.customerDetailsDiv = false;
      this.makePaymentElement = true;
    },
    back() {
      this.$router.push("/account-opening/account-type");
    },
       login() {
      this.$router.push("/account-opening/login");
    },
    submitForm() {

      this.setDefaults();

      this.postNoAuthAndNoBaseUrl(
        URLS.processAccount,
        this.customer,
        "Successful Request",
        null,
        true
      ).then((res) => {
      console.log('shshshs');
      console.log(res);
        if (!res) return;
        if (res.errors) return (this.errors = res.errors);
        if (res.body.accountNumber !== null) {

          this.title = 'Complete';
          this.message = 'Thank you for choosing TN CyberTech Bank. Your account number is ' + res.body.accountNumber + ' and will be linked automatically to transfer funds to your EcoCash wallet.';
          this.subTitle = 'TN CyberTech Bank';
          this.success = true;
          this.logoutButton = true;
          this.loadingRequest = false;
          // Clear all state after successful submission
          this.resetAllState();

        } else {
          if (res.body.requestType === "ECOCASH_DEPOSIT") {
            this.title = 'Sorry, Payment Authorization Failed'
            this.success = false;
            this.message = 'Click the button below to retry the payment process.';
            this.retryButton = true;
            this.logoutButton = true;
            this.loadingRequest = false;
          }
          this.title = 'Very Sorry, An Error Has Occurred'
          this.success = false;
          this.message = 'Click the button below to retry the payment process. If the error persists, please contact us on 0808 8888 or customerservice@stewardbank.co.zw for assistance.';
          this.retryButton = true;
          this.logoutButton = true;
          this.loadingRequest = false;
        }
      });
    },
    resetAllState() {
      this.authStore.$reset();
      this.customerStore.$reset();
      this.accountOpeningStore.$reset();
      clearPersistedState();
    },
    ...baseMethods,
  }
};
</script>